export const BarChartComponentStyles = {
  barChartContainer: {
    cursor: "pointer",
    marginLeft: "-20px",
    "@media screen and (max-width: 599px)": {
      marginLeft: "-30px",
    },
  },
};
